import { render, staticRenderFns } from "./LabaRugi.vue?vue&type=template&id=a8b59c24"
import script from "./LabaRugi.vue?vue&type=script&lang=js"
export * from "./LabaRugi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports